import React from "react";
import classnames from "classnames";

import {__} from '@wordpress/i18n';

import {useStoreCartVouchers} from "./use-store-cart-vouchers";
import VouchersForms from "./vouchers-forms";
import AppliedVouchersList from "./applied-vouchers-list";
import AppliedPromotionsList from "./applied-promotions-list";
import AppliedGiftCardsList from "./applied-gift-cards-list";
import PromotionsForm from "./promotions-form";

const Vouchers = () => {
	const {isAnyVoucherApplied, isAnyGiftCardApplied, isAnyPromotionApplied, getAllPromotions, getValidPromotions} = useStoreCartVouchers();

	if (!isAnyVoucherApplied() && !isAnyGiftCardApplied() && !isAnyPromotionApplied()) {
		return (
			<>
				{getAllPromotions() || getValidPromotions() ? (
					<>
						<span className="wp-block-woocommerce-cart-order-summary-heading-block wc-block-cart__totals-title">{
							__('Select promotion', 'voucherify')
						}</span>
						<div className={classnames(
							"wp-block-woocommerce-cart-order-summary-subtotal-block",
							"wc-block-components-totals-wrapper"
						)}>
							<PromotionsForm />
						</div>
					</>
				) : null}

				<span className="wp-block-woocommerce-cart-order-summary-heading-block wc-block-cart__totals-title">{
					__('Add coupon or gift card', 'voucherify')
				}</span>
				<VouchersForms/>
			</>
		);
	} else {
		return (
			<>
				{isAnyPromotionApplied() ? <AppliedPromotionsList /> : null}
				{isAnyVoucherApplied() ? <AppliedVouchersList /> : null}
				{isAnyGiftCardApplied() ? <AppliedGiftCardsList /> : null}
			</>
		);
	}
}

export default Vouchers;
